import { render, staticRenderFns } from "./TurnaroundServerTable.vue?vue&type=template&id=4ad7804c"
import script from "./TurnaroundServerTable.vue?vue&type=script&lang=js"
export * from "./TurnaroundServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports